<template>
  <div @click="selectAddress" class="address-list-item">{{ address.label }}</div>
</template>
<script>
export default {
  props: {
    address: Object
  },
  methods: {
    selectAddress: function() {
      this.$emit("select", this.$props.address);
    }
  }
};
</script>